import { render, staticRenderFns } from "./StatisticsFeedback.vue?vue&type=template&id=c0e873c6&"
import script from "./StatisticsFeedback.vue?vue&type=script&lang=js&"
export * from "./StatisticsFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports